import {
  CustomErrorInvariant,
  makeCustomErrorInvariant,
  makeRethrower,
  WatershedError,
  WatershedErrorOptions,
} from './WatershedError';

/**
 * Thrown when an operation is not allowed in the current state of the resource
 * (e.g. invalid status transition, or the resource is in a state that conflicts
 * with the requested operation).
 */
export class InvalidStateError extends WatershedError {
  status = 409;
  constructor(message?: string, options?: WatershedErrorOptions) {
    super('CONFLICT', message, options);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, InvalidStateError);
    }
    Object.setPrototypeOf(this, InvalidStateError.prototype);
  }

  static invariant: CustomErrorInvariant =
    makeCustomErrorInvariant(InvalidStateError);
  static wrapAndRethrow = makeRethrower(InvalidStateError);
}
